<div class="p-grid">

    <!-- menuBar -->
    <div class="p-col-12">
      <p-menubar [model]="menuItems">
        <ng-template pTemplate="start" style="width: 100%;">
          <div style="width: fit-content; float: left;">
            <p-dropdown [options]="recentItems" id="recentItems" (onChange)="recentUpdate()" [(ngModel)]="selectedRecent"
              optionLabel="label" appendTo="body" >
            </p-dropdown>
          </div>
          <span class="p-input-icon-left" style="float: right; margin: 2px 5px 0px 5px;">
            <i class="pi pi-search"></i>
            <input pInputText type="text" [(ngModel)]="globalFilterInput" placeholder="Search..." />
          </span>
        </ng-template>
        <ng-template pTemplate="end" style="width: 100%;">
        </ng-template>
      </p-menubar>
    </div>

    <!-- stepsBar -->
    <div class="p-col-12" *ngIf="app.currentUser.casesStepBar">
      <div style="overflow-x: auto; width: 100%;">
        <div class="card" style="padding: 15px 10px; min-width: 768px;">
          <div class="p-steps">
            <ul role="tablist">
              <li *ngFor="let stage of caseStagesAll; let i = index;">
                <a (click)="stepClicked(i, stage.id)" [ngClass]="{'active': selectedStep === (i + 1)}">
                  <span class="p-steps-number">{{ stage.cases ? stage.cases.length : 0 }}</span>
                  <span class="p-steps-title overview-box-name">{{ stage.name }}</span>
                </a>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>

    <!-- bodyArea -->
    <div class="p-col-12">
      <!-- list and split view -->
      <div *ngIf="(selectedView == 'list' || selectedView == 'split')">
        <div class="p-grid">
          <div [ngClass]="{'p-col-12 p-lg-12': selectedView=='list', 'p-col-12 p-lg-3':selectedView=='split'}">
            <div class="card">
              <p-contextMenu #cm [model]="configMenuItemsCM"></p-contextMenu>
              <p-table #cases [columns]="caseCols" [value]="casesData | globalFilter:globalFilterInput"
                [paginator]="true" [showCurrentPageReport]="true"
                currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
                [rowsPerPageOptions]="[10,15,25,50,100]" [rows]="15" selectionMode="single"
                [(selection)]="selectedCase" dataKey="id"
                (onRowSelect)="onRowSelect($event); caseCols = caseByNameCols; selectedView='split'"
                (onRowUnselect)="selectedCase = null; caseColsAll = caseColsAllTemp; caseCols = caseColsAll; selectedView='list'"
                [(contextMenuSelection)]="selectedCase" [contextMenu]="cm" [scrollable]="true"
                [style]="{width:'100%'}">
                <ng-template pTemplate="colgroup" let-columns>
                  <colgroup>
                    <ng-container *ngFor="let col of columns">
                      <col *ngIf="col.show" style="width:auto">
                    </ng-container>
                  </colgroup>
                </ng-template>
                <ng-template pTemplate="header" let-columns>
                  <tr>
                    <ng-container *ngFor="let col of columns">
                      <th *ngIf="col.show" [pSortableColumn]="col.field">
                        {{col.header}}
                        <p-sortIcon [field]="col.field" ariaLabel="Activate to sort"
                          ariaLabelDesc="Activate to sort in descending order"
                          ariaLabelAsc="Activate to sort in ascending order">
                        </p-sortIcon>
                        <span class="pi pi-filter p-mr-2 filtericon"
                          (click)="$event.stopPropagation(); curCol = col; op.toggle($event)">
                        </span>
                      </th>
                    </ng-container>
                  </tr>
                </ng-template>
                <ng-template pTemplate="body" let-rowData let-columns="columns">
                  <tr [pSelectableRow]="rowData" [pContextMenuRow]="rowData">
                    <ng-container *ngFor="let col of columns">
                      <td *ngIf="col.show" style="text-align: left;">
                        {{rowData[col.field]}}
                      </td>
                    </ng-container>
                  </tr>
                </ng-template>
              </p-table>
              <p-overlayPanel #op [showCloseIcon]="false" appendTo="body" [dismissable]="true">
                <ng-template pTemplate>
                  <input pInputText type="text" #inputS [(ngModel)]="curCol.value"
                    (input)="cases.filter(curCol.value, curCol.field, 'contains')"
                    placeholder="Search by {{curCol.header}}" class="p-column-filter"
                    [value]="cases.filters[curCol.field] ? cases.filters[curCol.field].value : ''">
                </ng-template>
              </p-overlayPanel>
            </div>
          </div>
          <div class="p-col-12 p-lg-9" *ngIf="selectedView == 'split' && selectedCase">
            <div class="card">
              <div class="p-grid">
                <div class="p-col-12">
                  <p-menu #configmenu id="config_menu" [model]="configMenuItems" [popup]="true"></p-menu>
                  <div class="tabviewIcons">
                    <div class="btnBars" (click)="configmenu.toggle($event)">
                      <i class="pi pi-bars"></i>
                    </div>
                    <div class="btnBars" (click)="backListView()">
                      <i class="pi pi-times"></i>
                    </div>
                  </div>
                  <p-tabView>
                    <p-tabPanel header="Overview">
                      <div class="arrow-steps">
                        <div class="p-grid">
                          <div class="p-col-12">
                            <ng-container *ngFor="let stage of caseStagesActual; let i = index;">
                              <div class="step" [ngClass]="{ 'current': i+1 === curIndex }"
                                [ngStyle]="{ width: caseStagesActual.length > 2 ? (100 / caseStagesActual.length) + '%' : '10%', maxWidth: 100 / caseStagesActual.length > 16.667 ? 100 / caseStages.length + '%' : '15%' }"
                                (click)="updateCurrentStage(i+1, stage.id)"><span>{{ stage.name }}</span></div>
                            </ng-container>
                          </div>
                        </div>
                      </div>
                      <div class="p-grid" style="margin-bottom: 10px;">
                        <ng-container *ngFor="let col of caseCols2">
                          <div class="p-col" *ngIf="col.show">
                            <div class="leaddesc card">
                              <div class="label">{{col.header}}</div>
                              <div class="leaddescName" (click)="showViewCase({id:selectedId})">
                                {{filteredCases[0][col.field]}}
                              </div>
                            </div>
                          </div>
                        </ng-container>
                      </div>
                      <p-panel header="Comments">
                        <ng-template pTemplate="icons">
                          <div class="btnBars" (click)="showAddComment({id:selectedId})">
                            <i class="pi pi-plus"></i>
                          </div>
                        </ng-template>
                        <div class="p-grid shared-activities border-bottom" *ngFor="let com of selectedCase.comments">
                          <div class="p-col-12">
                            <h6 class="p-mb-1">
                              <img class="pull-left" [src]="selectedCase.imageUrl" [alt]="selectedCase.assoName" />
                              {{ selectedCase.caseAssociation }} - {{ selectedCase.assoName }}
                              <span class="pull-right">{{ selectedCase.createdDate | localDate }} </span>
                            </h6>
                            <p>
                              {{com.comment.comment}}
                              <span class="pull-right">{{com.comment.isPublic}}</span>
                            </p>
                          </div>
                        </div>
                      </p-panel>
                    </p-tabPanel>
                  </p-tabView>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- kanban view -->
      <div *ngIf="selectedView == 'kanban'">
        <div class="p-grid">
          <div class="p-col-12">
            <div class="board">
              <div class="board-wrapper">
                <div class="board-columns" cdkDropListGroup>
                  <ng-container *ngFor="let stage of caseStages; let i = index;">
                    <div class="board-column" [ngClass]="{'autoWidth1':selectedCase}"
                    [ngStyle]="{ width: caseStages.length > 2 ? 100 / caseStages.length + '%' : '100%', borderTop: '4px solid ' + stage.color }"
                    [id]="stage.id" cdkDropList [cdkDropListData]="stage.cases" (cdkDropListDropped)="drop($event)">
                      <div class="column-title">
                        {{ stage.name }}
                      </div>
                      <div class="tasks-container" [ngClass]="{'tasks-container1': !app.currentUser.caseStepBar}">

                        <div class="task" [id]="'case-' + j"
                          [ngClass]="{'taskActive':selectedCase && selectedCase.id == case.id}"
                          (click)="kanbanItemClicked(case,stage);"
                          *ngFor="let case of stage.cases | globalFilter:globalFilterInput; let j = index;"
                          [ngStyle]="{ borderLeft: '4px solid ' + stage.color }" cdkDrag>
                          <div class="p-grid w-100 p-ml-1">
                            <div class="p-col-12" style="padding: 0;">
                              <div style="margin-top: 0px;" class="p-grid p-mr-1">
                                <div class="p-col-7" style="padding-bottom: 0;">
                                  <p class="p-mb-1"><strong>{{ case.caseNo }}</strong></p>
                                  <p class="p-mb-1">{{case.caseAssociation}}</p>
                                  <p class="p-mb-1">{{case.assoName}}</p>
                                </div>
                                <div class="p-col-5" style="padding-bottom: 0;padding-right: 0;">
                                  <ng-container *ngFor="let col of caseCols3">
                                    <ng-container *ngIf="col.show && col.move">
                                      <p class="p-mb-1" pTooltip="{{ case[col.field] }}">
                                        {{ (case[col.field].length>10)? (case[col.field] | slice:0:10)+'...':(case[col.field]) }}
                                      </p>
                                    </ng-container>
                                  </ng-container>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </ng-container>


                  <!-- Kanban Detail View -->
                  <div class="board-column" *ngIf="selectedCase" [ngClass]="{'autoWidth2':selectedCase}">
                    <div class="p-grid">
                      <div class="p-col-12">
                        <p-menu #configmenu id="config_menu" [model]="configMenuItems" [popup]="true"></p-menu>
                        <div class="tabviewIcons">
                          <div class="btnBars" (click)="configmenu.toggle($event)">
                            <i class="pi pi-bars"></i>
                          </div>
                          <div class="btnBars" (click)="selectedCase=null; caseStages = caseStagesActual;">
                            <i class="pi pi-times"></i>
                          </div>
                        </div>
                        <p-tabView>
                          <p-tabPanel header="Overview">
                            <div class="arrow-steps">
                              <div class="p-grid">
                                <div class="p-col-12">
                                  <ng-container *ngFor="let stage of caseStagesActual; let i = index;">
                                    <div class="step" [ngClass]="{ 'current': i === curIndex }"
                                      [ngStyle]="{ width: caseStagesActual.length > 2 ? (100 / caseStagesActual.length) + '%' : '10%', maxWidth: 100 / caseStagesActual.length > 16.667 ? 100 / caseStages.length + '%' : '15%' }"
                                      (click)="updateCurrentStage(i, stage.id)"><span>{{ stage.name }}</span></div>
                                  </ng-container>
                                </div>
                              </div>
                            </div>
                            <div class="p-grid" style="margin-bottom: 10px;">
                              <ng-container *ngFor="let col of caseCols2">
                                <div class="p-col" *ngIf="col.show">
                                  <div class="leaddesc card">
                                    <div class="label">{{col.header}}</div>
                                    <div class="leaddescName" (click)="showViewCase({id:selectedId})">
                                      {{filteredCases[0][col.field]}}
                                    </div>
                                  </div>
                                </div>
                              </ng-container>
                            </div>
                            <p-panel header="Comments">
                              <ng-template pTemplate="icons">
                                <div class="btnBars" (click)="showAddComment({id:selectedId})">
                                  <i class="pi pi-plus"></i>
                                </div>
                              </ng-template>
                              <div class="p-grid shared-activities border-bottom" *ngFor="let com of selectedCase.comments">
                                <div class="p-col-12">
                                  <h6 class="p-mb-1">
                                    <img class="pull-left" [src]="selectedCase.imageUrl" [alt]="selectedCase.assoName" />
                                    {{ selectedCase.caseAssociation }} - {{ selectedCase.assoName }}
                                    <span class="pull-right">{{ selectedCase.createdDate | localDate }}</span>
                                  </h6>
                                  <p>
                                    {{com.comment.comment}}
                                    <span class="pull-right">{{com.comment.isPublic}}</span>
                                  </p>
                                </div>
                              </div>
                            </p-panel>
                          </p-tabPanel>
                        </p-tabView>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

  </div>


  <!-- add new case dialog -->
  <p-dialog header="Add New Case" [(visible)]="displayCaseAdd" [modal]="true" [responsive]="true" [closable]="false"
    [style]="{width: '60vw'}">
    <form (ngSubmit)="saveCase()" #createCase="ngForm">
      <div class="header">
        <h5>Case Information</h5>
      </div>
      <div class="card">
        <div class="p-field p-formgrid p-grid">
          <div class="p-col-12 p-lg-6">
            <label>Case Association <span style="color: red;">*</span></label>
            <p-dropdown [options]="caseAssociation" [(ngModel)]="selectedCaseAssociation" name="caseAssociation"
              optionLabel="name"  (onChange)="getValues()" placeholder="Case Association"
              appendTo="body" required #caseAsso="ngModel"
              [ngClass]="{ 'p-invalid': caseAsso.invalid && (caseAsso.touched || caseAsso.dirty) }"></p-dropdown>
              <small *ngIf="caseAsso.invalid && (caseAsso.touched || caseAsso.dirty)" class="p-invalid">
                Case Association is required</small>
          </div>
          <div class="p-col-12 p-lg-6">
            <label>Association Name <span style="color: red;">*</span></label>
            <p-autoComplete [(ngModel)]="associationName" #associationNameDD name="associationNames"
              [suggestions]="associationNames" field="businessName" [completeOnFocus]="true" #assoName="ngModel"
              (completeMethod)="search($event.query)" id="associationNames" appendTo="body" required
              [ngClass]="{ 'p-invalid': assoName.invalid && (assoName.touched || assoName.dirty) }">
            </p-autoComplete>
            <small *ngIf="assoName.invalid && (assoName.touched || assoName.dirty)" class="p-invalid">
              Association Name is required</small>
          </div>
        </div>
        <div class="p-field p-formgrid p-grid">
          <div class="p-col-12 p-lg-6">
            <label>Contact Name</label>
            <p-autoComplete [(ngModel)]="contactNameFromAPI" #contactNameDD name="contactNames"
              [suggestions]="contactNames" field="businessName" [completeOnFocus]="true"
              (completeMethod)="searchContact($event.query)" id="contactNames" appendTo="body">
            </p-autoComplete>
          </div>
          <div class="p-col-12 p-lg-6">
            <label>Contact Email Address</label>
            <input pInputText type="text" [(ngModel)]="caseTemp.contactEmail" id="contactEmail" name="contactEmail"
            pattern="^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,6})+$" #emailinput="ngModel"
            [ngClass]="{ 'p-invalid': emailinput.invalid && (emailinput.touched || emailinput.dirty) }"/>
            <small *ngIf="emailinput.errors && emailinput.errors.pattern" class="p-invalid">
              Email is invalid</small>
          </div>
        </div>
        <div class="p-field p-formgrid p-grid">
          <div class="p-col-12 p-lg-6">
            <label>Contact Phone Number</label>
            <input pInputText type="text" [(ngModel)]="caseTemp.contactPhone" id="contactPhone" name="contactPhone"/>
          </div>
          <div class="p-col-12 p-lg-6">
            <label>Source</label>
            <p-dropdown [options]="sources" [(ngModel)]="selectedSource" optionLabel="name"
              placeholder="Select Source" [ngModelOptions]="{standalone: true}" appendTo="body"></p-dropdown>
          </div>
        </div>
        <div class="p-field p-grid">
          <div class="p-col-12 p-lg-6">
            <label>Category</label>
            <p-dropdown [options]="categories" [(ngModel)]="selectedCategory" optionLabel="name"
              placeholder="Select Category" [ngModelOptions]="{standalone: true}" appendTo="body"></p-dropdown>
          </div>
          <div class="p-col-12 p-lg-6">
            <label>Sub - Category</label>
            <p-dropdown [options]="subCates" [(ngModel)]="selectedSubCate" optionLabel="name"
              placeholder="Select Sub Category" [ngModelOptions]="{standalone: true}" appendTo="body"></p-dropdown>
          </div>
        </div>
        <div class="p-field p-grid">
          <div class="p-col-12 p-lg-6">
            <label>Priority</label>
            <p-dropdown [options]="priorities" [(ngModel)]="selectedPriority" optionLabel="name"
              placeholder="Select Priority" [ngModelOptions]="{standalone: true}" appendTo="body"></p-dropdown>
          </div>
          <div class="p-col-12 p-lg-6">
            <label>Share Files (Max Size 2MB) <i class="pi pi-exclamation-circle"
                [escape]="false" [pTooltip]="multiLineTooltip" tooltipPosition="top"></i></label>
            <p-fileUpload name="myfile[]" url="./upload.php" mode="basic" maxFileSize="1000000" accept="image/*"></p-fileUpload>
          </div>
        </div>
        <div class="p-field p-grid">
          <div class="p-col-12">
            <label>Case Details</label>
            <textarea pInputTextarea name="description" [(ngModel)]="caseTemp.comments[0].comment.comment" rows="3"></textarea>
          </div>
        </div>
      </div>
    </form>
    <p-footer>
      <button type="button" pButton (click)="cancelAddCase()" label="Cancel" class="p-button-secondary"></button>
      <button type="button" pButton (click)="createCase.ngSubmit.emit()" class="p-button-success"
        [disabled]="createCase.form.invalid" label="Save"></button>
    </p-footer>
  </p-dialog>

  <p-dialog header="Edit Case" [(visible)]="displayCaseEdit" [modal]="true" [responsive]="true" [closable]="false"
    [style]="{width: '60vw'}">
    <form (ngSubmit)="updateEditContact()" #updateCase="ngForm">
      <div class="header">
        <h5>Case Information</h5>
      </div>
      <div class="card">
        <div class="p-field p-formgrid p-grid">
          <div class="p-col-12 p-lg-6">
            <label>Case Association</label>
            <p-dropdown [options]="caseAssociation" [(ngModel)]="selectedCaseAssociation" name="caseAssociation"
              optionLabel="name"  (onChange)="getValues()" placeholder="Case Association" appendTo="body"></p-dropdown>
          </div>
          <div class="p-col-12 p-lg-6">
            <label>Association Name</label>
            <p-autoComplete [(ngModel)]="associationName" #associationNameDD name="associationNames"
              [suggestions]="associationNames" field="businessName" [completeOnFocus]="true"
              (completeMethod)="search($event.query)" id="associationNames" appendTo="body">
            </p-autoComplete>
          </div>
        </div>
        <div class="p-field p-formgrid p-grid">
          <div class="p-col-12 p-lg-6">
            <label>Contact Name <span style="color: red;">*</span></label>
            <p-autoComplete [(ngModel)]="contactNameFromAPI" #contactNameDD name="contactNames"
              [suggestions]="contactNames" field="businessName" [completeOnFocus]="true" #contactName="ngModel"
              (completeMethod)="searchContact($event.query)" id="contactNames" required appendTo="body"
              [ngClass]="{ 'p-invalid': contactName.invalid && (contactName.touched || contactName.dirty) }">
            </p-autoComplete>
              <small *ngIf="contactName.invalid && (contactName.touched || contactName.dirty)" class="p-invalid">
              Contact Name is required</small>
          </div>
          <div class="p-col-12 p-lg-6">
            <label>Contact Email Address</label>
            <input pInputText type="text" [(ngModel)]="caseTemp.contactEmail" id="contactEmail" name="contactEmail"
            pattern="^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,6})+$" #emailinput="ngModel"
            [ngClass]="{ 'p-invalid': emailinput.invalid && (emailinput.touched || emailinput.dirty) }"/>
            <small *ngIf="emailinput.errors && emailinput.errors.pattern" class="p-invalid">
              Email is invalid</small>
          </div>
        </div>
        <div class="p-field p-formgrid p-grid">
          <div class="p-col-12 p-lg-6">
            <label>Contact Phone Number</label>
            <input pInputText type="text" [(ngModel)]="caseTemp.contactPhone" id="contactPhone" name="contactPhone"/>
          </div>
          <div class="p-col-12 p-lg-6">
            <label>Source</label>
            <p-dropdown [options]="sources" [(ngModel)]="selectedSource" optionLabel="name"
              placeholder="Select Source" [ngModelOptions]="{standalone: true}" appendTo="body"></p-dropdown>
          </div>
        </div>
        <div class="p-field p-grid">
          <div class="p-col-12 p-lg-6">
            <label>Category</label>
            <p-dropdown [options]="categories" [(ngModel)]="selectedCategory" optionLabel="name"
              placeholder="Select Category" [ngModelOptions]="{standalone: true}" appendTo="body"></p-dropdown>
          </div>
          <div class="p-col-12 p-lg-6">
            <label>Sub - Category</label>
            <p-dropdown [options]="subCates" [(ngModel)]="selectedSubCate" optionLabel="name"
              placeholder="Select Sub Category" [ngModelOptions]="{standalone: true}" appendTo="body"></p-dropdown>
          </div>
        </div>
        <div class="p-field p-grid">
          <div class="p-col-12 p-lg-6">
            <label>Priority</label>
            <p-dropdown [options]="priorities" [(ngModel)]="selectedPriority" optionLabel="name"
              placeholder="Select Priority" [ngModelOptions]="{standalone: true}" appendTo="body"></p-dropdown>
          </div>
          <div class="p-col-12 p-lg-6">
            <label>Share Files (Max Size 2MB) <i class="pi pi-exclamation-circle"
                [escape]="false" [pTooltip]="multiLineTooltip" tooltipPosition="top"></i></label>
            <p-fileUpload name="myfile[]" url="./upload.php" mode="basic" maxFileSize="1000000" accept="image/*"></p-fileUpload>
          </div>
        </div>
        <div class="p-field p-grid">
          <div class="p-col-12">
            <label>Case Details</label>
            <textarea pInputTextarea name="description" [(ngModel)]="caseTemp.comments[0].comment.comment" rows="3"></textarea>
          </div>
        </div>
      </div>
    </form>
    <p-footer>
      <button type="button" pButton (click)="displayCaseEdit = false" label="Cancel"
        class="p-button-secondary"></button>
      <button type="button" pButton (click)="updateCase.ngSubmit.emit()" class="p-button-success"
        [disabled]="updateCase.form.invalid" label="Save"></button>
    </p-footer>
  </p-dialog>

  <p-dialog [(visible)]="displayCaseView" [modal]="true" [responsive]="true" [closable]="false" [style]="{width: '60vw'}">
      <ng-template pTemplate="header">
        <h5 style="width: 100%;">Case View Page
          <span style="float: right;cursor: pointer;" (click)="showEditCase({id:caseTemp.id})"
            class="pi pi-pencil"></span>
        </h5>
      </ng-template>
      <div class="header">
        <h5>Case Information</h5>
      </div>
      <div class="card">
        <div class="p-field p-formgrid p-grid">
          <div class="p-col-12 p-lg-6">
            <label>Case Association</label>
            <p-dropdown [options]="caseAssociation" [(ngModel)]="selectedCaseAssociation" name="caseAssociation"
              optionLabel="name"  (onChange)="getValues()" placeholder="Case Association" disabled></p-dropdown>
          </div>
          <div class="p-col-12 p-lg-6">
            <label>Association Name</label>
            <p-autoComplete [(ngModel)]="associationName" #associationNameDD name="associationNames"
              [suggestions]="associationNames" field="businessName" [completeOnFocus]="true"
              (completeMethod)="search($event.query)" id="associationNames" disabled>
            </p-autoComplete>
          </div>
        </div>
        <div class="p-field p-formgrid p-grid">
          <div class="p-col-12 p-lg-6">
            <label>Contact Name <span style="color: red;">*</span></label>
            <p-autoComplete [(ngModel)]="contactNameFromAPI" #contactNameDD name="contactNames"
              [suggestions]="contactNames" field="businessName" [completeOnFocus]="true" #contactName="ngModel"
              (completeMethod)="searchContact($event.query)" id="contactNames" disabled>
            </p-autoComplete>
          </div>
          <div class="p-col-12 p-lg-6">
            <label>Contact Email Address</label>
            <input pInputText type="text" disabled [(ngModel)]="caseTemp.contactEmail" id="contactEmail" name="contactEmail"/>
          </div>
        </div>
        <div class="p-field p-formgrid p-grid">
          <div class="p-col-12 p-lg-6">
            <label>Contact Phone Number</label>
            <input pInputText type="text" disabled [(ngModel)]="caseTemp.contactPhone" id="contactPhone" name="contactPhone"/>
          </div>
          <div class="p-col-12 p-lg-6">
            <label>Source</label>
            <p-dropdown [options]="sources" [(ngModel)]="selectedSource" optionLabel="name"
              placeholder="Select Source" [ngModelOptions]="{standalone: true}" disabled></p-dropdown>
          </div>
        </div>
        <div class="p-field p-grid">
          <div class="p-col-12 p-lg-6">
            <label>Category</label>
            <p-dropdown [options]="categories" [(ngModel)]="selectedCategory" optionLabel="name"
              placeholder="Select Category" [ngModelOptions]="{standalone: true}" disabled></p-dropdown>
          </div>
          <div class="p-col-12 p-lg-6">
            <label>Sub - Category</label>
            <p-dropdown [options]="subCates" [(ngModel)]="selectedSubCate" optionLabel="name"
              placeholder="Select Sub Category" [ngModelOptions]="{standalone: true}" disabled></p-dropdown>
          </div>
        </div>
        <div class="p-field p-grid">
          <div class="p-col-12 p-lg-6">
            <label>Priority</label>
            <p-dropdown [options]="priorities" [(ngModel)]="selectedPriority" optionLabel="name"
              placeholder="Select Priority" [ngModelOptions]="{standalone: true}" disabled></p-dropdown>
          </div>
          <div class="p-col-12 p-lg-6">
            <label>Share Files (Max Size 2MB) <i class="pi pi-exclamation-circle" disabled
                [escape]="false" [pTooltip]="multiLineTooltip" tooltipPosition="top"></i></label>
            <p-fileUpload disabled name="myfile[]" url="./upload.php" mode="basic" maxFileSize="1000000" accept="image/*"></p-fileUpload>
          </div>
        </div>
        <div class="p-field p-grid">
          <div class="p-col-12">
            <label>Case Details</label>
            <textarea pInputTextarea disabled name="description" [(ngModel)]="caseTemp.comments[0].comment.comment" rows="3"></textarea>
          </div>
        </div>
      </div>
    <p-footer>
      <button type="button" pButton (click)="displayCaseView=false" label="Cancel" class="p-button-secondary"></button>
    </p-footer>
  </p-dialog>

  <!-- case settings dialog -->
  <p-dialog header="Case Settings" [(visible)]="displaySettings" [style]="{width: '450px'}" [modal]="true">
    <div class="p-grid" style="height: 400px;">
      <div class="p-col-12 p-lg-4 sidemenu">
        <div class="card">
          <ul>
            <li (click)="showDiv.stepsbar = true;showDiv.views = false;showDiv.collists = false;showDiv.details = false;showDiv.config = false;">
              <a (click)="onClick(1)" [ngClass]="{'active': tab==='tab1'}">Display Steps Bar</a>
            </li>
            <li (click)="showDiv.views = true;showDiv.stepsbar = false;showDiv.collists = false;showDiv.details = false;showDiv.kanban = false;showDiv.config = false;">
              <a (click)="onClick(2)" [ngClass]="{'active': tab==='tab2'}">Default View</a>
            </li>
            <li (click)="showDiv.collists = true;showDiv.stepsbar = false;showDiv.views = false;showDiv.details = false;showDiv.kanban = false;showDiv.config = false;">
              <a (click)="onClick(3)" [ngClass]="{'active': tab==='tab3'}">List View Columns</a>
            </li>
            <li (click)="showDiv.details = true;showDiv.stepsbar = false;showDiv.views = false;showDiv.collists = false;showDiv.kanban = false;showDiv.config = false;">
              <a (click)="onClick(4)" [ngClass]="{'active': tab==='tab4'}">Details View Block</a>
            </li>
            <li (click)="showDiv.kanban = true;showDiv.stepsbar = false;showDiv.views = false;showDiv.collists = false;showDiv.details = false;showDiv.config = false;">
              <a (click)="onClick(5)" [ngClass]="{'active': tab==='tab5'}">Kanban View Data</a>
            </li>
            <li *ngIf="app.isConfigured" (click)="showDiv.config = true;showDiv.stepsbar = false;showDiv.views = false;showDiv.collists = false;showDiv.details = false;showDiv.kanban = false;">
              <a (click)="onClick(6)" [ngClass]="{'active': tab==='tab6'}">Configure Email</a>
            </li>
          </ul>
        </div>
      </div>
      <div class="p-col-12 p-lg-8">
        <div class="card">
          <div *ngIf="showDiv.stepsbar">
            <div class="colList">
              <p-checkbox [(ngModel)]="tempCaseStepBar" binary="true" inputId="binary"></p-checkbox> {{tempCaseStepBar ?
              'On' : 'Off'}}
            </div>
          </div>
          <div *ngIf="showDiv.views">
            <div class="colList">
              <p-dropdown [options]="availableViews" [(ngModel)]="tempView"></p-dropdown>
            </div>
          </div>
          <div *ngIf="showDiv.collists">
            <div class="p-d-flex">
              <div>
                <h6>Column Selection (Max 7)</h6>
              </div>
            </div>
            <div cdkDropList (cdkDropListDropped)="dropCol($event)">
              <ng-container *ngFor="let col of tempCols; let i = index">
                <div class="colList p-d-flex" cdkDrag [cdkDragDisabled]="i === 0 || tempCols[i].header == 'Case No.' || tempCols[i].header == 'Cases'"
                  appendTo="body">
                  <i class="fa fa-bars" *ngIf="!(i === 0 || tempCols[i].header == 'Case No.' || tempCols[i].header == 'Cases')"
                    style="margin-right: 10px; color:lightgray"></i>
                  <i class="fa fa-minus" *ngIf="(i === 0 || tempCols[i].header == 'Case No.' || tempCols[i].header == 'Cases')"
                    style="margin-right: 10px; color:lightgray"></i>
                  <p-checkbox [(ngModel)]="tempCols[i].checked" type="checkbox" binary="true" inputId="binary"
                  [disabled]="((!tempCols[i].checked && maxNo) || i === 0 || tempCols[i].header == 'Case No.' || tempCols[i].header == 'Cases')"
                  (onChange)="onChange($event.checked)" class="p-mr-2"></p-checkbox>
                  &nbsp;&nbsp;{{tempCols[i].header}}
                </div>
              </ng-container>
            </div>
          </div>
          <div *ngIf="showDiv.details">
            <div class="p-d-flex">
              <div>
                <h6>Column Selection (Max 6)</h6>
              </div>
            </div>
            <div cdkDropList (cdkDropListDropped)="dropCol($event)">
              <ng-container *ngFor="let col of tempCols2; let i = index">
                <div class="colList p-d-flex" cdkDrag [cdkDragDisabled]="i === 0 || tempCols2[i].header == 'Case No.'"
                  appendTo="body">
                  <i class="fa fa-bars" *ngIf="!(i === 0 || tempCols2[i].header == 'Case No.')"
                    style="margin-right: 10px; color:lightgray"></i>
                  <i class="fa fa-minus" *ngIf="(i === 0 || tempCols2[i].header == 'Case No.')"
                    style="margin-right: 10px; color:lightgray"></i>
                  <p-checkbox [(ngModel)]="tempCols2[i].checked" type="checkbox" binary="true" inputId="binary"
                    [disabled]="((!tempCols2[i].checked && maxNo2) || i === 0 || tempCols2[i].header == 'Case No.')"
                    (onChange)="onChange2($event.checked)" class="p-mr-2"></p-checkbox>
                  {{tempCols2[i].header}}
                </div>
              </ng-container>
            </div>
          </div>
          <div *ngIf="showDiv.kanban">
            <div class="p-d-flex">
              <div>
                <h6>Column Selection (Max 6)</h6>
              </div>
            </div>
            <div cdkDropList (cdkDropListDropped)="dropCol($event)">
              <ng-container *ngFor="let col of tempCols3; let i = index">
                <div class="colList p-d-flex" cdkDrag appendTo="body"
                [cdkDragDisabled]="i === 0 || tempCols3[i].header == 'Case No.' || tempCols3[i].header == 'Association Type' || tempCols3[i].header == 'Association Name'">
                  <i class="fa fa-bars" *ngIf="!(i === 0 || tempCols3[i].header == 'Case No.' || tempCols3[i].header == 'Association Type' || tempCols3[i].header == 'Association Name')"
                    style="margin-right: 10px; color:lightgray"></i>
                  <i class="fa fa-minus" *ngIf="(i === 0 || tempCols3[i].header == 'Case No.' || tempCols3[i].header == 'Association Type' || tempCols3[i].header == 'Association Name')"
                    style="margin-right: 10px; color:lightgray"></i>
                  <p-checkbox [(ngModel)]="tempCols3[i].checked" type="checkbox" binary="true" inputId="binary"
                    [disabled]="((!tempCols3[i].checked && maxNo3) || i === 0 || tempCols3[i].header == 'Case No.' || tempCols3[i].header == 'Association Type' || tempCols3[i].header == 'Association Name')"
                    (onChange)="onChange3($event.checked)" class="p-mr-2"></p-checkbox>
                  {{tempCols3[i].header}}
                </div>
              </ng-container>
            </div>
          </div>
          <div *ngIf="showDiv.config">
            <button pButton (click)="app.checkConfigurationAndPerformOps()" label="Sign Out"></button>
          </div>
        </div>
      </div>
    </div>
    <ng-template pTemplate="footer">
      <p-button (click)="displaySettings=false" label="Cancel" styleClass="p-button-secondary"></p-button>
      <p-button (click)="saveSettings()" label="Save"></p-button>
    </ng-template>
  </p-dialog>

  <p-dialog [closable]="false" [(visible)]="displayCommentAdd" [modal]="true"
      [style]="{width: '55%', minWidth: '55%'}">
      <p-header>
          <h5 class="p-d-inline-block p-mb-0">Case ID: {{caseTemp.caseNo}}</h5>
      </p-header>
      <form #createComment="ngForm" (ngSubmit)="addComment()">
          <div class="p-field p-formgrid p-grid">
              <div class="p-col-12">
                <p-selectButton [options]="options" [(ngModel)]="commentTemp.comment.isPublic" [ngModelOptions]="{standalone: true}"></p-selectButton>
                  <label class="p-mt-4">Comments <span style="color: red;">*</span></label>
                  <textarea required="true" rows="5" cols="100" [(ngModel)]="commentTemp.comment.comment"
                      placeholder="Enter Comment" pInputTextarea id="comment" name="comment"
                      [ngClass]="{ 'p-invalid': comment.invalid && (comment.touched || comment.dirty) }"
                      #comment="ngModel" required="true">
                  </textarea>
                  <small class="p-invalid" *ngIf="comment.invalid && (comment.touched || comment.dirty)">Comment is
                      required</small>
              </div>
          </div>
      </form>
      <ng-template pTemplate="footer">
          <button pButton label="Cancel" (click)="displayCommentAdd=false" class="p-button-secondary"></button>
          <button pButton label="Save" (click)="createComment.ngSubmit.emit()"></button>
      </ng-template>
  </p-dialog>

  <p-confirmDialog [style]="{width: '20vw'}" [baseZIndex]="1000000"></p-confirmDialog>
